import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

export const verifiedUserGuard: CanActivateFn = () => {
  const user = inject(AuthService).currentUser();
  if (user?.role === 'user' && user.isVerified) return true;
  inject(Router).navigate(['/account/verify-required']);
  return false;
};
